import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GetFinancialParameter } from '../models/financial-parameter/get';
import { AddFinancialParameter } from '../models/financial-parameter/add';

@Injectable({
  providedIn: 'root'
})
export class FinancialParameterService {

  constructor(private _http: HttpClient) {}

  public getAll(): Observable<GetFinancialParameter[]> {
    return this._http.get<GetFinancialParameter[]>(`${environment.api.url}/FinancialParameter/All`);
  }

  public getByCode(code: string): Observable<GetFinancialParameter> {
    return this._http.get<GetFinancialParameter>(`${environment.api.url}/FinancialParameter/${code}`);
  }

  public add(param: AddFinancialParameter): Observable<void> {
    return this._http.post<void>(`${environment.api.url}/FinancialParameter/Add`, param);
  }
}
